module.exports = "/images/check.svg?7b3238e7a5c7b11228b0a44664c2088a";